var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.67172C0 1.89729 0.259016 1.2584 0.777027 0.755051C1.29504 0.251676 1.96848 0 2.7973 0C3.61133 0 4.26994 0.247796 4.77317 0.743434C5.29118 1.25455 5.55019 1.92052 5.55019 2.74141C5.55019 3.48485 5.29859 4.10436 4.79537 4.6C4.27736 5.11111 3.59653 5.36667 2.7529 5.36667H2.7307C1.91666 5.36667 1.25805 5.11111 0.754826 4.6C0.251601 4.08889 0 3.44612 0 2.67172ZM0.28861 23V7.48081H5.21718V23H0.28861ZM7.94788 23H12.8764V14.3343C12.8764 13.7922 12.9357 13.3741 13.0541 13.0798C13.2613 12.5532 13.5758 12.1079 13.9976 11.7439C14.4194 11.38 14.9485 11.198 15.5849 11.198C17.2426 11.198 18.0714 12.3673 18.0714 14.7061V23H23V14.102C23 11.8098 22.482 10.0712 21.4459 8.88636C20.4099 7.70152 19.0409 7.10909 17.3388 7.10909C15.4295 7.10909 13.9421 7.96869 12.8764 9.68788V9.73434H12.8542L12.8764 9.68788V7.48081H7.94788C7.97747 7.97642 7.99228 9.51749 7.99228 12.104C7.99228 14.6906 7.97747 18.3225 7.94788 23Z",
    fill: "#ADADAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.17a962bffdfdfec21188bbe00d06f4ab.svg";
export { ForwardRef as ReactComponent };